import { useEffect, useState } from 'react';
import axios from '../../config/axiosInstance';

const useParticipantData = (eventPK, selectedHost) => {
    const [participantTypes, setParticipantTypes] = useState([]);
    const [participantStates, setParticipantStates] = useState([]);
    const [programmePoints, setProgrammePoints] = useState([]);

    useEffect(() => {
        const fetchStatesAndTypes = async () => {
            if (!selectedHost || !eventPK) return;

            try {
                const { data: tokenData } = await axios.get(`/regasus/token?host=${selectedHost}`);
                const token = tokenData.access_token;

                const [statesRes, typesRes, ppsRes] = await Promise.all([
                    axios.get(`/regasus/participant-states?host=${selectedHost}&token=${encodeURIComponent(token)}`),
                    axios.get(`/regasus/event-participant-types/${eventPK}?host=${selectedHost}&token=${encodeURIComponent(token)}`),
                    axios.get(`/regasus/event-pps/${eventPK}?host=${selectedHost}&token=${encodeURIComponent(token)}`)
                ]);

                setParticipantStates(statesRes.data?.participantStates?.participantState || []);
                setParticipantTypes(typesRes.data?.participantTypes?.participantType || []);
                setProgrammePoints(ppsRes.data?.programmePoints?.programmePoint || []);
            } catch (error) {
                console.error('Error loading participant data:', error);
                setParticipantStates([]);
                setParticipantTypes([]);
                setProgrammePoints([]);
            }
        };

        fetchStatesAndTypes();
    }, [eventPK, selectedHost]);

    return { participantTypes, participantStates, programmePoints };
};

export default useParticipantData;